import {isDevelopment} from '../../../config/webpack.environment';

export class RetailRocket {
    track(callback) {
        (window['rrApiOnReady'] = window['rrApiOnReady'] || []).push(function() {
            try {
                callback();
            } catch (e) {
                if (isDevelopment) {
                    console.log(e);
                }
            }
        });
    }

    viewContentProduct(product) {
        let callback;
        if (product.is_offers) {
            callback = function() {
                rrApi.groupView(product.offers_id);
            };
        } else {
            callback = function() {
                rrApi.view(product.id);
            };
        }

        this.track(callback);
    }

    /**
     * @param categoryCode
     * @returns {boolean}
     */
    static isCategorySendTrack(categoryCode) {
        let excludeCategoriesCode = [
            'podarki',
            'podarki-bossu',
            'podarki-dlya-muzhchin',
            'dlya-kolleg',
            'dlya-podrug',
            'dlya-mamy',
            'dlya-lyubimoy',
            'rasprodazha',
            'povrezhdennaya-upakovka',
        ];

        return (excludeCategoriesCode.indexOf(categoryCode) === -1);
    }

    viewContentCategory(category) {
        if (RetailRocket.isCategorySendTrack(category.code)) {
            this.track(function() {
                rrApi.categoryView(category.id);
            });
        }
    }

    subscription(email) {
        this.track(function() {
            rrApi.welcomeSequence(email);
        });
    }

    subscriptionPopup(email) {
        this.track(function() {
            rrApi.welcomeSequence(email);
        });
    }

    oneClick(productId) {
        this.track(function() {
            rrApi.addToBasket(productId);
        });
    }

    addToCart(product) {
        this.track(function() {
            rrApi.addToBasket(product.id);
        });
    }

    orderTransaction(order, basket) {
        let params = {
            transaction: order.id,
            items: this.formatBasket(basket),
        };
        this.track(function() {
            rrApi.order(params);
        });
    }

    productAddToFavorite(params) {
        this.subscribeOnPriceDrop(params.email, [params.product]);
    }

    formatBasket(basket) {
        return basket.map((basketItem) => {
            return RetailRocket.formatBasketItem(basketItem);
        });
    }

    static formatBasketItem(basketItem) {
        return {
            id: basketItem.offer_id || basketItem.id,
            qnt: parseFloat(basketItem.quantity),
            price: parseFloat(basketItem.price),
        };
    }

    setCustomer(user) {
        if (!user.authorized) {
            return;
        }

        let phone = '7' + user['phone'];
        if (user.phone_format) {
            phone = user.phone_format;
        }

        this.track(function() {
            rrApi.setCustomer({
                customerId: user['user_id'],
                email: user['email'],
                phone: phone,
            });
        });
    }

    search() {
        this.track(function() {
            rrApi.search('search_phrase');
        });
    }

    /**
     * "Подписка на снижение цены"
     * @example rrApi.subscribeOnPriceDrop("null@gmail.com", [{id:3,price:3.9},{id:4,price:1.9}]);
     * @param email
     * @param arrayParams
     */
    subscribeOnPriceDrop(email, arrayParams) {
        this.track(function() {
            rrApi.subscribeOnPriceDrop(email, arrayParams);
        });
        this.logger('subscribeOnPriceDrop', [email, arrayParams]);

    }

    /**
     * Письмо с альтернативами отсутствующему товару
     * @param email
     * @param productId
     */
    subscribeOnItemBackInStock(email, productId) {
        this.track(function() {
            rrApi.subscribeOnItemBackInStock(email, productId);
        });
        this.logger('subscribeOnItemBackInStock', [email, productId]);
    }

    logger(methodName, params) {
        if (isDevelopment) {
            console.log(methodName);
            console.log(params);
        }
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/retailrocket.js